<template>
  <v-container fluid>
    <span class="title -tongue ml-5">
      Endereço para Correspondência
    </span>
    <v-form v-model="valid">
      <v-layout row>
        <v-flex xs6>
          <v-layout>
            <v-flex class="pr-1" xs8>
              <v-text-field
                  v-model="mailingAddress.responsible_name"
                  label="Nome do Responsável"
                  :rules="[validationRules.required]"
              />

            </v-flex>
            <v-flex class="pl-1" xs4>
              <v-text-field
                  v-model="mailingAddress.cellphone"
                  :mask="mailingAddress.cellphone.length < 11 ? '(##) ####-#####' : '(##) #####-####'"
                  label="Telefone"
                  :rules="[validationRules.required]"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4>
              <v-text-field
                  v-model="mailingAddress.zip_code"
                  label="CEP"
                  mask="##.###-###"
                  :rules="[validationRules.required]"

              />
            </v-flex>
            <v-flex>
              <v-btn
                  fab
                  small
                  primary
                  color="primary"
                  :disabled="mailingAddress.zip_code.length !== 8"
                  @click="fetchZipCodeForEntityAddress()"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="pr-1" xs8>
              <v-text-field
                  v-model="mailingAddress.street"
                  label="Logradouro"
                  :rules="[validationRules.required]"
              />
            </v-flex>
            <v-flex class="pl-1" xs4>
              <v-text-field
                  v-model="mailingAddress.number"
                  label="Número"
                  :rules="[validationRules.required]"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="pr-1" xs6>
              <v-text-field
                  v-model="mailingAddress.complement"
                  label="Complemento"


              />
            </v-flex>
            <v-flex class="pl-1" xs6>
              <v-text-field
                  v-model="mailingAddress.neighborhood"
                  label="Bairro"

                  :rules="[validationRules.required]"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="pr-1" xs4>
              <v-autocomplete
                  v-model="mailingAddress.federal_unit"
                  :items="federalUnits"
                  @change="fetchCities()"
                  :rules="[validationRules.required]"
                  label="Selecione um estado"
                  no-data-text="Nenhum resultado encontrado"
                  item-text="name"
                  item-value="id"
                  return-object
                  single-line/>
            </v-flex>
            <v-flex class="pl-1" xs8>
              <v-autocomplete
                  v-model="mailingAddress.city"
                  :items="cities"
                  :rules="[validationRules.required]"
                  label="Selecione uma cidade"
                  no-data-text="Nenhum resultado encontrado"
                  item-text="name"
                  item-value="id"
                  return-object
                  single-line/>
            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
      <v-divider class="mt-3 mb-3"/>
      <v-layout>
        <v-flex xs6>
          <v-layout justify-space-between>
            <v-btn flat @click="previousStep()">Voltar</v-btn>
            <v-btn
                :disabled="!valid"
                @click="mountMailingAddress()"
                color="primary"
            >
              Continuar
              <v-icon right>mdi-arrow-right mdi-18px</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import FederalUnitService from '@/services/FederalUnitService';
  import AddressService from '@/services/AddressService';
  import { find } from 'lodash';
  import validationRules from '@/mixins/validation-rules';
  import { mapActions } from 'vuex';

  export default {
    name: 'MailingAddress',
    mixins: [validationRules],
    async beforeMount() {
      this.federalUnits = await FederalUnitService.fetchFederalUnits()
    },
    data() {
      return {
        valid: false,
        validationRules,
        federalUnits: [],
        cities: [],
        mailingAddress: { cellphone: '', zip_code: '' }
      };
    },
    methods: {
      ...mapActions('newApplication', ['setMailingAddress', 'nextStep', 'previousStep', 'setValidSteps']),
      async fetchZipCodeForEntityAddress() {
        try {
          this.$store.dispatch('setLoadingDialog', true);

          const address = await AddressService.fetchZipCode(this.mailingAddress.zip_code)
          const federalUnitForEntityAddress = find(this.federalUnits, { acronym: address.acronym })
          this.cities = await FederalUnitService.fetchCities(federalUnitForEntityAddress.id)
          const cityForEntityAddress = find(this.cities, { name: address.city })

          this.mailingAddress = {
            ...this.mailingAddress, ...address,
            federal_unit: federalUnitForEntityAddress,
            city: cityForEntityAddress
          }
        } catch (e) {
          alert('Erro ao Consultar CEP')
        }
        this.$store.dispatch('setLoadingDialog', false);
      },
      async fetchCities() {
        this.cities = await FederalUnitService.fetchCities(this.mailingAddress.federal_unit.id)
      },

      mountMailingAddress() {
        this.setMailingAddress(this.mailingAddress);
        this.nextStep()
      },
    },
    watch: {
      valid() {
        this.setValidSteps(this.valid);
      }
    }
  };
</script>
